import type { AreaUnits, Units } from '@turf/turf';
import { EditorMode } from '~/common/types';
import type { BasicMapStore } from '../..';

export const clearMeasurement = (store: BasicMapStore) => {
  store.currentObjectId = undefined;
  store.setEditorMode(EditorMode.None);
};

export interface TUnit {
  unitType: Units;
  label: string;
  unitSystem: 'imperial' | 'metric';
}

export const lengthUnits: TUnit[] = [
  {
    unitType: 'inches',
    label: 'Inches',
    unitSystem: 'imperial',
  },
  {
    unitType: 'feet',
    label: 'Feet',
    unitSystem: 'imperial',
  },
  {
    unitType: 'yards',
    label: 'Yards',
    unitSystem: 'imperial',
  },
  {
    unitType: 'miles',
    label: 'Miles',
    unitSystem: 'imperial',
  },
  {
    unitType: 'meters',
    label: 'Meters',
    unitSystem: 'metric',
  },
  {
    unitType: 'kilometers',
    label: 'Kilometers',
    unitSystem: 'metric',
  },
];

export interface TAreaUnit {
  unitType: AreaUnits;
  label: string;
  unitSystem: 'imperial' | 'metric';
}

export const areaUnits: TAreaUnit[] = [
  ...(lengthUnits as TAreaUnit[]),
  {
    unitType: 'acres',
    label: 'Acres',
    unitSystem: 'imperial',
  },
];
